import axios from "axios";
import { APP_URL } from "../../../config/api";
import { errorMessage } from "../../errorHandle";

export const uploadQuestionBank = (file) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/upload-question-bank`,
        data: file,
      })
      .then((res) => {
        dispatch({
          type: QUESTION.UPLOAD_QUESTION_BANK,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, QUESTION.ERROR));
      });
  };
};

export const getQuestionBank = (search) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-question-bank`,
        data: search,
      })
      .then((res) => {
        dispatch({
          type: QUESTION.GET_QUESTION_BANK,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, QUESTION.ERROR));
      });
  };
};

export const addRandomQuestions = (parm) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/add-random-questions`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: QUESTION.ADD_RANDOM_QUESTION,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, QUESTION.ERROR));
      });
  };
};


export const addAutomaticQuestions = (parm) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/add-automatic-questions`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: QUESTION.ADD_AUTOMATIC_QUESTION,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, QUESTION.ERROR));
      });
  };
};


export const getLanguageIdentifeid = (parm) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-language-identified`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: QUESTION.GET_IDENTIFED,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, QUESTION.ERROR));
      });
  };
};


export const getAssessmentQuestions = (parm) => {
  return (dispatch) => {
    dispatch({
      type: QUESTION.REQUEST,
    });
    axios
      .request({
        method: "post",
        url: `${APP_URL}/get-assessment-questions`,
        data: parm,
      })
      .then((res) => {
        dispatch({
          type: QUESTION.GET_ASSESSMENT_QUESTION,
          payload: res.data,
        });
      })
      .catch((error) => {
        dispatch(errorMessage(error, QUESTION.ERROR));
      });
  };
};
 




const TAG = "QUESTION_";

export const QUESTION = {
  ERROR: TAG + "ERROR",
  REQUEST: TAG + "REQUEST",
  UPLOAD_QUESTION_BANK: TAG + "UPLOAD_QUESTION_BANK",
  GET_QUESTION_BANK: "GET_QUESTION_BANK",
  ADD_RANDOM_QUESTION: "ADD_RANDOM_QUESTION",
  ADD_AUTOMATIC_QUESTION: "ADD_AUTOMATIC_QUESTION",
  GET_IDENTIFED: "GET_IDENTIFED",
  GET_ASSESSMENT_QUESTION: "GET_ASSESSMENT_QUESTION",
};
